import { CheckBoxField } from './CheckBoxField';

export default CheckBoxField;
